import TitleBar1 from './titleBar1';
export default TitleBar1;
